import imgUpload from "@/components/inputComponent/imgUpload"
import myInput from "@/components/inputComponent/inputComponent";
import mySelect from "@/components/inputComponent/selectComponent";
import myAddress from "@/components/inputComponent/addressComponent";
import myDate from "@/components/inputComponent/dateComponent";
import listModel from "@/components/inputComponent/listModel";


export default (Vue) => {
	// 注册组件
	// 使用Vue.component()注册组件时，全局id自动作为组件的名称
	// 也就是说，此时第一参数为组件的名称
	Vue.component('imgUpload',imgUpload)
	Vue.component('myInput',myInput)
	Vue.component('mySelect',mySelect)
	Vue.component('myAddress',myAddress)
	Vue.component('myDate',myDate)
	Vue.component('listModel',listModel)
}



// WEBPACK FOOTER //
// ./src/common/inputComponent.js